import { useEffect } from 'react';

import { useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { SuccessCard } from '@identity/presentation/components/base';
import { accountStatusKey, PROFILE_ROUTE } from '@identity/presentation/constants';
import { useIdentityUserId } from '@identity/presentation/hooks';

/**
 * The screen that closes the password change.
 *
 * The account status is invalidated on mount and not on the click, so the request travels while the
 * user reads the confirmation and the profile comes back already showing the new date.
 *
 * Nothing is signed out: the backend keeps every session alive after this write, so the exit goes
 * back to Mi perfil and not through the login.
 */
export const PasswordChangedScreen = () => {
  const { t } = useTranslation('identity');
  const history = useHistory();
  const queryClient = useQueryClient();
  const userId = useIdentityUserId();

  useEffect(() => {
    queryClient.invalidateQueries(accountStatusKey(userId));
  }, [queryClient, userId]);

  return (
    <SuccessCard
      actionLabel={t('profile.changePassword.done.action')}
      description={t('profile.changePassword.done.body')}
      onAction={() => history.replace(PROFILE_ROUTE)}
      title={t('profile.changePassword.done.title')}
    />
  );
};
